import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import moment from "moment";
import { styled } from "@mui/material/styles";
import Button from "../../../../component-lib/Molecules/button/Button";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../../component-lib/Atoms/heading/EventEHRHeading";
import { TEXT_CONSTANTS } from "../../../../utils/text-constants/textConstants";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "16px 24px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "436px",
    width: "708px",
    maxWidth: "none",
  },
}));

interface ViewGroupDialogProps {
  isOpen: boolean;
  groupData: any;
  handleClose: () => void;
}

const ViewGroupDialog: React.FC<ViewGroupDialogProps> = ({
  isOpen,
  groupData,
  handleClose,
}) => {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title="Group Details" />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent dividers>
          {groupData ? (
            <div
              style={{
                padding: "24px 16PX",
                display: "grid",
                gap: "24px 16px",
                gridTemplateColumns: "1fr 1fr",
                border: "1px solid #E8E8E8",
              }}
            >
              <p>
                <strong>Group Name:</strong> {groupData?.name || ""}
              </p>
              <p>
                <strong>Created Date:</strong> {groupData?.createdAt ? moment(groupData.createdAt).format("MM/DD/YYYY") : ""}
              </p>
              <p>
                <strong>Members:</strong> {groupData?._count?.memebers || 0}
              </p>
              <p>
                <strong>Created By:</strong> {groupData?.creator ? `${groupData.creator.firstName} ${groupData.creator.lastName}` : ""}
              </p>
                <div style={{ gridColumn: "1 / -1" }}>
                  <p>
                    <strong>Members List:</strong> {groupData?.memebers?.map((member: any) => {
                      const person = member?.users || member?.adminUser;
                      return `${person?.firstName || ""} ${person?.lastName || ""}`.trim();
                    }).filter(Boolean).join(", ") || "No members"}
                  </p>
                </div>
            </div>
          ) : (
            <p>No group data available</p>
          )}
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button
              label={TEXT_CONSTANTS?.CLOSE}
              variant="contained"
              onClickCb={handleClose}
              style={{
                width: "120px",
                height: "44px",
                padding: "12px 20px",
                fontSize: "16px",
                marginRight: "6px",
              }}
            ></Button>
          </div>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

export default ViewGroupDialog;
